/**
 * Authentication hook using Supabase Auth.
 * Re-exports useAuth from auth-context for convenience.
 */

import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/api/client';
import type { OrganisationContext } from '@/api/schemas';

// Re-export auth context hook and types
export { useAuth, type AuthUser } from '@/contexts/auth-context';

/**
 * Hook to get current user and organization context.
 */
export function useMe() {
  return useQuery<OrganisationContext>({
    queryKey: ['me'],
    queryFn: () => authApi.getMe(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
}

